type LpEnvironment = 'shared' | 'prod';

export interface LpConfig {
  siteId: string;
  locales: Record<string, number>;
}

export type LpConfigForEnv = Record<LpEnvironment, LpConfig>;

/*
  SDEs are a LiveEngage specific format of data
  For info what data can be stored, see
  https://developers.liveperson.com/web-tag-sdes.html
  and
  https://developers.liveperson.com/engagement-attributes-types-of-engagement-attributes.html
*/
export type SDE =
  | {
      type: 'lead';
      lead: { topic: string }; // A contact form topic (a readable English string)
    }
  | {
      type: 'ctmrinfo';
      info: { role: string }; // Used for passing an auth token for the bot
    }
  | {
      type: 'mrktInfo';
      info: { campaignId: string }; // used for passing supportRequestId UUID
    };

interface QuickReply {
  type: 'button' | 'text';
  title: string;
}

export enum LpChatMessageSource {
  agent = 'agent',
  visitor = 'visitor',
}

type RichContentText = {
  elements: QuickReply[];
};

export interface LpChatMessage {
  '@id': number;
  by?: string;
  metadata?: {
    type: 'CbBotResponseMetaData' | string;
  }[];
  conId: string;
  history: boolean;
  originatorId: string;
  isWelcomeMessage?: boolean;
  quickReplies?: {
    replies: QuickReply[];
  };
  source: LpChatMessageSource;
  text: string | RichContentText;
  textType?: 'richContent' | 'plain';
  type: 'richContent' | 'line';
  time: number;
}
